/* @fflow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';
import { download } from 'utils/ajax';

export type DownloadContainerType = {
  style: Object,
  children: any,
  body: string,
  format: string,
  filename: string,
  customDataTestID?: string,
};

export default function DownloadContainer({
  style,
  children,
  body,
  format,
  filename,
  customDataTestID,
}: DownloadContainerType): React.Element {
  return (
    <span
      data-testid={customDataTestID}
      onClick={() => download(body, format, filename)}
      style={style}
      >
      { children }
    </span>
  );
}
